import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import Catalouge from './Catalouge';
import About from './About';
import Contact from './Contact';

function App() {
  return (
   <>
   <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalouge" element={<Catalouge />} /> 
         <Route path="/about" element={<About />} /> 
          <Route path="/contact" element={<Contact />} /> 
        
      </Routes>
    </BrowserRouter>
   
   
   </>
  );
}

export default App;
